import React from 'react'
import { Droppable, Draggable } from "react-beautiful-dnd";
import styles from '../Template2/style.module.css';
const DraggableMissions = ({ experience, droppableId, staticPreview = false }) => {
  if (staticPreview) {
    return (
      <ul>
        {experience.missions.map((mission, idx) => (
          <li key={`${droppableId}-${idx}`} className={styles.semibold}>
            {mission}
          </li>
        ))}
      </ul>
    );
  }

  return (
    <Droppable droppableId={droppableId}>
      {(provided) => (
        <ul
          {...provided.droppableProps}
          ref={provided.innerRef}
        >
          {experience.missions.map((mission, idx) => (
            <Draggable key={`${droppableId}-${idx}`} draggableId={`${droppableId}-${idx}`} index={idx}>
              {(provided) => (
                <li 
                  ref={provided.innerRef}
                  {...provided.draggableProps}
                  {...provided.dragHandleProps}
                  className={styles.semibold}
                >
                  {mission}
                </li>
              )}
            </Draggable>
          ))}
          {provided.placeholder}
        </ul>
      )}
    </Droppable>
  )
}

export default DraggableMissions
